const isTouchDevice = () => {
    return 'ontouchstart' in document.documentElement;
};

export {
    isTouchDevice,
}